import { RouteRecordRaw } from 'vue-router'
import MainLayout from '@/layout/MainLayout.vue'
import DocumentAgreementIndex from '@/pages/document-agreement/Index.vue'
import DocumentAgreementSingle from '@/pages/document-agreement/single/DocumentAgreementSingle.vue'
import DocumentAgreementList from '@/pages/document-agreement/DocumentAgreementList.vue'
import DocumentAgreementDashboard from '@/pages/document-agreement/DocumentAgreementDashboard.vue'
import DocumentAgreementPreview from '@/pages/document-agreement/single/tabs/Preview.vue'
import DocumentAgreementRequisites from '@/pages/document-agreement/single/tabs/Requisites.vue'
import DocumentAgreementVersions from '@/pages/document-agreement/single/tabs/Versions.vue'
import DocumentAgreementComments from '@/pages/document-agreement/single/tabs/Comments.vue'
import DocumentAgreementLogs from '@/pages/document-agreement/single/tabs/Logs.vue'
import DocumentAgreementRoutes from '@/pages/document-agreement/single/tabs/routes/Routes.vue'
import DocumentAgreementRelatedDocuments from '@/pages/document-agreement/single/tabs/RelatedDocuments.vue'
import DocumentAgreementExtraDocuments from '@/pages/document-agreement/single/tabs/ExtraDocuments.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/document-agreement/:id(\\d+)',
    redirect: (to) => ({
      name: 'document-agreement-single-preview',
      params: { id: to.params.id },
    }),
  },
  {
    path: '/document-agreement',
    name: 'document-agreement',
    component: MainLayout,
    meta: {
      title: 'Договори',
      resource: 'document-agreements',
    },
    redirect: { name: 'document-agreement-dashboard' },
    children: [
      {
        path: 'dashboard',
        name: 'document-agreement-dashboard',
        component: DocumentAgreementDashboard,
        meta: {
          title: 'Дашборд',
          resource: 'document-agreements',
        },
      },
      {
        path: 'list',
        name: 'document-agreement-list',
        component: DocumentAgreementIndex,
        redirect: { name: 'document-agreement-new' },
        meta: {
          resource: 'document-agreements',
        },
        children: [
          {
            path: ':id',
            name: 'document-agreement-single',
            component: DocumentAgreementSingle,
            meta: {
              title: 'Документ',
              tabList: true,
            },
            redirect: { name: 'document-agreement-single-preview' },
            children: [
              {
                path: 'preview',
                name: 'document-agreement-single-preview',
                component: DocumentAgreementPreview,
                meta: {
                  title: 'Огляд',
                },
              },
              {
                path: 'requisites',
                name: 'document-agreement-single-requisites',
                component: DocumentAgreementRequisites,
                meta: {
                  title: 'Реквізити',
                },
              },
              {
                path: 'versions',
                name: 'document-agreement-single-versions',
                component: DocumentAgreementVersions,
                meta: {
                  title: 'Версії',
                },
              },
              {
                path: 'comments',
                name: 'document-agreement-single-comments',
                component: DocumentAgreementComments,
                meta: {
                  title: 'Коментарі',
                },
              },
              {
                path: 'logs',
                name: 'document-agreement-single-logs',
                component: DocumentAgreementLogs,
                meta: {
                  title: 'Історія',
                },
              },
              {
                path: 'routes',
                name: 'document-agreement-single-routes',
                component: DocumentAgreementRoutes,
                meta: {
                  title: 'Маршрут',
                },
              },
              {
                path: 'related',
                name: 'document-agreement-single-related',
                component: DocumentAgreementRelatedDocuments,
                meta: {
                  title: "Пов'язані документи",
                },
              },
              {
                path: 'extra',
                name: 'document-agreement-single-extra',
                component: DocumentAgreementExtraDocuments,
                meta: {
                  title: 'Додаткові документи',
                },
              },
            ],
          },

          {
            path: 'new',
            name: 'document-agreement-new',
            component: DocumentAgreementList,
            meta: {
              title: 'Нові',
            },
          },
          {
            path: 'revision',
            name: 'document-agreement-revision',
            component: DocumentAgreementList,
            meta: {
              title: 'Доопрацювання',
            },
          },
          {
            path: 'me',
            name: 'document-agreement-me',
            component: DocumentAgreementList,
            meta: {
              title: 'Мені на візування',
            },
          },
          {
            path: 'agreed',
            name: 'document-agreement-agreed',
            component: DocumentAgreementList,
            meta: {
              title: 'Завізовані мною',
            },
          },
        ],
      },
    ],
  },
]

export default routes
